import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import { useEnvironment } from "../../Shared/components/EnvironmentProvider/EnvironmentProvider";
import Loading from "../../Shared/components/loading";
import { useGetProviderInfo } from "./BillingInformation.request";
import { PaymentProcessor } from "./Shared/types/PaymentProcessorTypes";
export const BillingInformationContext = createContext({
    // Stripe
    clientSecret: undefined,
    setClientSecret: () => { },
    paymentIntentId: undefined,
    setPaymentIntentId: () => { },
    // Authorize.Net
    token: undefined,
    setToken: () => { },
    paymentProfileId: undefined,
    setPaymentProfileId: () => { },
    // Tap
    publicKey: undefined,
    setPublicKey: () => { },
    // UI State
    addedNewCard: false,
    setAddedNewCard: () => { },
    doesPaymentIntentExist: false,
    setDoesPaymentIntentExist: () => { },
    dismissedAddPaymentModal: false,
    setDismissedAddPaymentModal: () => { },
    // Payment processor
    paymentProcessor: PaymentProcessor.UNKNOWN,
    setPaymentProcessor: () => { },
    // Provider info
    authorizeUrl: "",
    // Utility
    resetContext: () => { },
});
export const BillingInformationContextProvider = ({ children }) => {
    const { environment } = useEnvironment();
    // Payment processor type
    const [paymentProcessor, setPaymentProcessor] = useState(PaymentProcessor.UNKNOWN);
    // Stripe state
    const [clientSecret, setClientSecret] = useState();
    const [paymentIntentId, setPaymentIntentId] = useState();
    // Authorize.Net state
    const [token, setToken] = useState();
    const [paymentProfileId, setPaymentProfileId] = useState();
    // Tap state
    const [publicKey, setPublicKey] = useState();
    // UI state
    const [addedNewCard, setAddedNewCard] = useState(false);
    const [doesPaymentIntentExist, setDoesPaymentIntentExist] = useState(false);
    const [dismissedAddPaymentModal, setDismissedAddPaymentModal] = useState(false);
    const { data, loading, error } = useGetProviderInfo();
    /**
     * Resets payment processor UI state.
     * Note: This does NOT clear payment data (cards, gift cards) as that's now in SWR cache.
     * To refresh payment data, use mutate() from usePaymentMethodsQuery.
     */
    const resetContext = () => {
        setClientSecret(undefined);
        setToken(undefined);
        setPublicKey(undefined);
        setPaymentIntentId(undefined);
        setDoesPaymentIntentExist(false);
        setDismissedAddPaymentModal(false);
    };
    if (loading || !data || error) {
        const loadingText = !!error ? error : environment === "localhost" ? "Billing Information Provider..." : undefined;
        return _jsx(Loading, { error: !!error, text: loadingText, viewportHeight: "75vh" });
    }
    return (_jsx(BillingInformationContext.Provider, Object.assign({ value: {
            // Stripe
            clientSecret,
            setClientSecret,
            paymentIntentId,
            setPaymentIntentId,
            // Authorize.Net
            token,
            setToken,
            paymentProfileId,
            setPaymentProfileId,
            // Tap
            publicKey,
            setPublicKey,
            // UI State
            addedNewCard,
            setAddedNewCard,
            doesPaymentIntentExist,
            setDoesPaymentIntentExist,
            dismissedAddPaymentModal,
            setDismissedAddPaymentModal,
            // Payment processor
            paymentProcessor,
            setPaymentProcessor,
            // Provider info
            stripePublishableKey: data === null || data === void 0 ? void 0 : data.stripePublishableKey,
            authorizeUrl: data === null || data === void 0 ? void 0 : data.authorizeUrl,
            // Utility
            resetContext,
        } }, { children: children })));
};
